import { BuilderEstimatorSteps } from "@/enums/BuilderEstimatorSteps";
import {
  IBuilderEstimatorFormData,
  ISelectInclusions,
  ISelectInternalColours,
  ISelectDesign,
  ISelectExternalColours,
  ISelectFacade,
} from "@/types/BuilderEstimatorFormData";
import { OptionalUpgrade } from "@/types/OptionalUpgradeInterface";

type StepMapping = {
  step: BuilderEstimatorSteps;
  key:
    | keyof ISelectDesign
    | keyof ISelectFacade
    | keyof ISelectExternalColours
    | keyof ISelectInternalColours
    | keyof ISelectInclusions;
  priceField: "price" | "basePrice";
};

const PRICE_MAPPINGS: StepMapping[] = [
  {
    step: BuilderEstimatorSteps.SELECT_DESIGN,
    key: "houseDesign",
    priceField: "basePrice",
  },
  {
    step: BuilderEstimatorSteps.SELECT_FACADE,
    key: "facade",
    priceField: "price",
  },
  {
    step: BuilderEstimatorSteps.SELECT_EXTERNAL_COLOURS,
    key: "externalColorScheme",
    priceField: "price",
  },
  {
    step: BuilderEstimatorSteps.SELECT_INTERNAL_COLOURS,
    key: "internalColorScheme",
    priceField: "price",
  },
  {
    step: BuilderEstimatorSteps.SELECT_INCLUSIONS,
    key: "inclusionPack",
    priceField: "price",
  },
];

const calculateOptionalUpgradesTotal = (
  upgrades: OptionalUpgrade[] | null
): number => {
  if (!upgrades) return 0;

  return upgrades.reduce((sum, upgrade) => sum + (upgrade.price || 0), 0);
};

export const calculateBuilderEstimatorQuoteSummaryTotalPrice = (
  formData: IBuilderEstimatorFormData
): string => {
  const total =
    PRICE_MAPPINGS.reduce((sum, { step, key, priceField }) => {
      const stepData = formData[step];

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore - Safe to ignore as we know the mapping is correct
      return sum + (stepData?.[key]?.[priceField] || 0);
    }, 0) +
    calculateOptionalUpgradesTotal(
      formData[BuilderEstimatorSteps.OPTIONAL_UPGRADES]?.optionalUpgrades
    );

  return new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
    maximumFractionDigits: 0,
  }).format(total);
};
